import { FC } from 'react'

import AprovacaoProvider from './AprovacaoProvider'
import ConfigCompradorProvider from './ConfigCompradorProvider'
import ConfigProvider from './ConfigProvider'
import ListagemProvider from './ListagemProvider'

const FollowUpFornecedorProvider: FC = ({ children }) => {
  return (
    <ConfigProvider>
      <ConfigCompradorProvider>
        <AprovacaoProvider>
          <ListagemProvider>{children}</ListagemProvider>
        </AprovacaoProvider>
      </ConfigCompradorProvider>
    </ConfigProvider>
  )
}

export default FollowUpFornecedorProvider
